import { Component, OnInit, OnDestroy, PipeTransform } from "@angular/core";
import $ from 'jquery';
import { AuthService } from "../../../services/auth.service";
import { StorageService } from "../../../services/storage.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { PatientService } from "../../../services/patient.service";
import { GlobalService } from "../../../services/global.service";
import { ToastrService } from "ngx-toastr";
import { ImageCropperComponent, CropperSettings } from "ngx-img-cropper";
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService, SharedModule} from 'primeng/api';
//import { NullAstVisitor } from "@angular/compiler";
import { UserService } from "../../../services/user.service";
import { Response } from "selenium-webdriver/http";
import { openClose } from "../../../animations";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { orderBy } from "lodash";
import { DatePipe } from "@angular/common";
import { UtilService } from "../../../util/utilService";
import { CanComponentDeactivate } from "../../../can-deactivate.guard";
import { DoctorService } from '../../../services/doctor.service';

const complaints = ["Abd Pain", "Back Pain", "Bed Wetting", "Blood In Urine", "Boil", "Burning Micturation", "Burning While Urination ", "Burns", "Chest Pain", "Cold", "Crying", "Cuts", "Decresed Oral Intake", "Dental Caries", "Dizzying", "Driblling Of Urine", "Dry Cough", "Dry Cough With Expectoation", "Dry Itchy Rash", "Dry Skin", "Dysuria", "Ear Ache", "Ears Itching", "Eneuresis", "Excessive Crying ", "Exclusive Breast Feeding", "Eye Discharge", "Eye Redness", "Fever", "Fever With Chills", "Flat Feet", "Fore Skin Ballooning", "Foul Smell", "Gasses Distension", "Green Sticky Flood Mucus", "Gritting Of Teeth", "Hard Stools", "Head Banging", "Head Injury", "Headache", "Hernia", "Hydrocoel ", "Hydrocole ", "Hyperactive", "Inguinal", "Insect Bite", "Irregular Bowels", "Irritable ", "Jaundice", "Leg Pains", "Lesions  ", "Loose Motions", "Loose Weight Gain", "Maculo Papular Rash", "Mixed Feed", "Mouth Odur", "Mouth Ulcers", "Mucoid", "Nail Biting", "Nasal Blockade", "Nausea", "Neck Glands Swelling", "Nephritis Acute", "Noisy Resperation", "Nose Bleed", "Pica", "Pilo Nephritis", "Poly Urea", "Poor Appetite/ Fussy Eater", "Poor Attention Span", "Poor Consantration", "Poor Wt And Ht", "Prickly Heat", "Rash", "Rash On Face", "Recurent Infections", "Restless At Night", "Runny Nose", "Slow In School", "Sneezing", "Sore Throat", "Stomach Pain", "Strain While Urination And Motion", "Sweating ++ ", "Teeth Grinding ", "Teething", "Temper Tantrums", "Thumb Sucking", "Tongue Coated", "Tooth Ache", "Trauma", "Umblical Hernia", "Urine Albumin", "Vomitting", "Well Visit", "Wheezing"];
const diagnosis = ["Abd. Colic", "Absecess", "Absescess", "Ac Gastritis", "Ac Sinusitis", "Actute Bronchitis", "Acute Gastritis", "Acute Gastroentritis", "Acute Laryngitis", "Acute Myalgia", "Acute Nephritis", "Acute Otitis Externa", "Acute Otitis Media", "Acute Otorhea", "Acute Pharyngitis", "Acute Pyoderma", "Acute Rhinitis", "Acute Tonsillitis (exudative)", "Acute Tonsillitis (pustular)", "Acute Urti", "Acute Urti, Viral", "Add/adhd/ld/autism/slow Learner", "Adenoids", "Allergic Rhinitis", "Allergy", "Amoebic Dysentry", "Anal Fissure", "Anemia", "Angiodoema", "Angioneurotic Edema", "Appendicitis", "Asthamatics", "Atopic Dermatitis", "Atypical Myco Bacterium", "Autism", "Bacillary Dysentry", "Bacteremia ", "Balanoposthitis", "Baleno Prosthesis", "Behaviral Disorders (temper Tantrunns/ Stubborn/pika)", "Bilat Thelarche", "Breast Abcess", "Breath Holding Spell", "Bronchiolicic", "Broncholitis", "Cah", "Cat Scratch Fever", "Cellulitis", "Central Precocius Puberty", "Cerebral Palsy", "Cervical Iymphadenitis", "Chicken Pox", "Chikungunia", "Childhood Asthma", "Chronic Diarrhoea", "Common Cold", "Congenital  Short Stature", "Congenital Heart Disease (acyanotic)", "Congenital Heart Disease (cyanotic)", "Congenital Horseshoe Kidney", "Conjunctivitis", "Constipation", "Contact Allergy", "Contact Dermatitis", "Cushing Syndrome", "Cystitis", "D Def", "Dandruff", "Dacryocystitis", "Dehydration", "Delayed M And M", "Dengue", "Dental Abscess", "Deviated Nasal Septum", "Df With Sec Infection", "Diaper Rash", "Diarrhoea", "Diarrhoea Drug Induce ", "Digeorge", "Dog Bite", "Downs Syndrome", "Drug Allergy", "Dry Dermatitis", "Dysentry", "Eczema", "Epilepsy", "Epispadion Pemopubic", "Epistaxis", "Epulse", "Erythema Nodosum", "Exercise Induced Asthma", "Eye Blepharitis", "Factitious Fever ", "Failure To Thrive ", "Familial Short Stature", "Faulty Food Habits", "Fecal Incontinence", "Fever Conversion", "Fever Convulsion", "Fever Without Focus ", "Food Poisoning", "Foreign Body", "Foreign Body Ingestion", "Fracture (tibia/fibula/humerus/radius)", "Fungal Infection", "Fussy Eater", "Gases", "Gerd", "Ghd", "Giardiasis ", "Gingivitis", "Gut Infection ", "Haematuria", "Hand Foot Mouth", "Head Injury", "Hema", "Hematuria", "Hernia", "Herpes ", "Herpes Simplex", "Herpingina", "Hfm", "Hin1", "Hunger Diarrhoea", "Hydrocoele", "Hyper Pigmentation", "Hypo  Epispadias", "Hypo-pigmentation", "Hypothyroid", "Hypothyroidism(aitd)", "Impetigo", "Inadequate Feeds ", "Indigestion", "Ineffective Diarrhoea", "Inffective Diarrhoea", "Inguinal Hernia", "Insect Bite", "Insect Bite Allergy", "Intercurrent Infection", "Jaundice", "Lactose Intolerance", "Laryngomalacia", "Lrti", "Lymphadenopathy", "Maculopapular Rash", "Malabsorption", "Malaria", "Measles ", "Meningocoel", "Mennorrhagea", "Mentally And Physically Challenged", "Mentally Challenged", "Mesenteric Adenitis", "Metabolic Syndrome", "Micro Cefali ", "Migraine", "Milia", "Motor Delay", "Mumps", "Nephrotic Syndrome", "Nocturnal Enuresis", "Nocturnal Enuress", "Nodular Urticaria", "Normal Child", "Normal New Born", "Nutritional Obesity", "Otalgia", "Over Feeding", "Overgrown Nail", "Paraphimosis", "Paratyphoid", "Paronychia", "Perianal Excoriation", "Pes Cavus", "Phimosis", "Physically Challenged", "Pica", "Pika", "Piles", "Pityriasis", "Pneumonia", "Poly Urea ", "Preterm Baby", "Prickly Heat", "Puberty", "Pulled Elbow ", "Pulmonary Kochs", "Puo", "Pyelonephritis", "Pyoderma", "Rad", "Recurrent Diarrhoea", "Refractive Error (re)", "Renal Calculai", "Rickets", "Scabies", "Scarlet Fever ", "Scoliosis", "Seborhic Dermatitis", "Severe Erosive Pangastritis", "Sga Sequel", "Short Febrile Illness", "Short Stature (const)", "Simple Seizure", "Sinusitis", "Small For Date ", "Smegma", "Spastic Dystonic ", "Spring Catarrh", "Staph", "Staph Skin Infection", "Stomatitis", "Stye", "Stye On Eye", "Swine Flu", "Syncope", "Synechia", "Teething", "Term-iugr", "Thorn Pricks ", "Thrombocytopenia", "Thrombocytosis", "Tinea", "Tinea Rosea", "Trauma", "Travel Diarrhea", "Typhoid", "Umbilical Hernia", "Undescended", "Urticaria", "Urticiria", "Uti", "Uvulitis", "Vasovagal Feet", "Viral Diarrhoea", "Viral Exanthem", "Viral Hepatitis", "Viral Syndrome", "Viral Warts", "Vitamin Def Of D", "Walri", "Weaning  Diarrhoea", "Well", "Well Child For Vaccination", "Winter Dermatitis", "Worm Infestation", "Xeroderma"];
const investigations = ['Urine Routine And Microscopy', 'Urine Culture And Sensitivity', 'Stool Routine And Microscopy', 'Hb Gram', 'Crp', 'Calcium', 'Alkaline Phospotase', 'Vitamin D Total', 'Hba1c', 'Esr', 'Adenoid X-ray', 'Chest X-ray', 'Serum Calcium', 'Serum Ferritin', 'Tsh', 'Usg', '2-decho', 'Usg Abd', 'Usg Abdomen For Renal', 'Parameters', 'Usg Brain', 'Ct Scan- Brain', 'Mri – Spine', 'Haemogrom', 'Dengue Ns', 'Dengue Antibodies', 'Pbs For Mp', 'Optimal For Malaria', 'Thyroid Functions', 'Stool Routine And Sensitivity', 'X Ray Adenoids Lat View', 'X Ray Pns', 'X Ray Chest', 'X Ray For #', 'Stool Culture And Sensitivity', 'Varicella Titles', 'Stool Culture And Sensitivity', 'Tuberculin', 'B 12', 'Ilipd Profile', 'Sgpt', 'Rft', 'T T Test', 'Reti Count', 'Hb Electro Phoresis', 'Lft', 'Bsl', 'Dmsa', 'Sgot', 'Usg Doppler', 'Take Extra Blood Sample', 'Take Blood Sample In Plain Bulb', 'Aso', 'Suger', 'Eeg', 'Widal', 'Holter', 'Tilt Table Test', 'Take Extra Blood Sample In Plain Bulb', 'Dtp', 'Dmsa', 'Viral Titres', 'Sick Ling', 'Dengue Igg And Igm', 'Monitor Urine Out Put And Color', 'Cpk', 'Us Through Af', 'Ct Scan', 'Cd 3', 'Cd 3', 'Ear Swab Culture', 'Collet In C/s Bottle', 'Blood Culture', 'Mcu', 'Pet Scan', 'Folvite', 'Complement', 'X Ray Spine', 'Ecg', 'Ggt', 'Hplc', 'Blood Group'];


const on_exam = ["Pallor Af Open", "Maculo Papillo Rash Al Over", "Widened Wrists", "Conducted Sounds", "No Lad", "Aebe", "Bilat Crepts", "Bilat Spasm", "Ear Discharge", "Ear Wax +", "Normal New Born", "Normal -genitalia", "Occ Crepts", "Rash", "S1s2", "Teething", "Weight Gain Good", "Be. Femorals", "Umblical Granuloma", "Tongue Coated", "N Umblicus", "Bilat Descendes Testes", "Diaper Rash", "Liver Palpable L0", "Spleen Palpavle S0", "Bowel Sounds N", "Abd- Nontender / Tender", "Abd- Gaurding +", "Cervical Ladenitis", "Bilat Idg", "Post Occipital Nodes", "Small", "Nontender", "Discrete", "Axillary Paipable", "Axillary Np", "Inguinal – Nodes", "Breast Nodule", "Bony Prominence", "N Joint Movements", "Bow Legs", "Knock Kness", "Flat Feet", "Febrile", "Chest Clear", "Throat - Noraml", "Ears – Normal", "Nose – Normal", "No – Lad", "Normal New Born Uv", "Neonate Mv", "Wt Gain Good", "Wt Gain Poor", "Wt Gain Slow", "Af – N", "Aebe S1s2 – No Murmor", "Be Femorals", "Skull / Spine / Palate N", "Cord Fallen", "Cord Not Fallen", "N Genitalia", "Testes Descended Bilat", "N Prepuce Hypdspadils", "N Normal", "Umbucal Granuloma", "Mild Stridor", "Ent-normal", "Abd Soft", "Dental Caries", "Sinus Tender / Non Tender", "Tonsils + +", "Aebe S1s2 ", "Urine Adequate", "Prickly Heat", "Posterior Cervical Nodes ", "Synechia", "Pnd", "Good Speech", "Aebe S1s2 Chest Clear", "Calf Mussels", "Scalp", "Gasses Distension", "Soft Systolic Mur Mur", "Runny Nose", "Bilat Jdj", "Less Salivation", "Epicanthal", "Murmur", "Perennial  Redness", "Posterior Cervical Node", "Anal Excoriation ", "Gaseous Distension", "Nostril Blockade", "Normal Milestons", "Inguinal Orifices  Normal", "Asa - Normal", "Partial Neck Holding", "Fore Skin Phy Phimosis", "Ns Normal", "Normal Milestones", "Intoeing", "Lymph Nodes ", "No Significant Lad ", "Nasal Discharge", "Cephalo Hemotona", "Foreskin Not Retractable", "Tonsils Enlarge"];
@Component({
  selector: "app-treatment",
  templateUrl: "./treatment.component.html",
  styleUrls: ["./treatment.component.scss"],
  animations: [openClose],
})
export class treatmentComponent implements OnInit, OnDestroy {
  userId:any = null;
  patientId:any = null;
  patient: any = { User: {} };
  profileImage:any = null;
  age: any = {};
  bloodGroups:any[] = [];
  drug:any = null;
  foodChoices:any[] = [];
  visitId:any = null;
  caseId:any = null;
  closeResult: any;
  medicine: any = { Drug: {} };
  medicineError:any = null;
  medicineList:any[] = [];
  editIndex:any = null;
  newPrescription: any = { Medicines: [] };
  drugs:any[] = [];
  totalQty = 0;
  ownPrescriptions:any[] = [];
  otherPrescriptions:any[] = [];
  originalDrugs:any[] = [];
  viewPrescriptionList:any[] = [];
  selectedPrescription:any= {};
  vitals:any = {};
  readOnly = false;
  prescriptionErrors:any = {};
  date = new Date();
  complaint: any = {};
  modalRef: any = null;
  modified: Boolean = false;
  addMedicineSection = false;
medicineInstructions:any[] = [];
  specialInstructions:any[] = [];
  deletedMedicines:any[] = [];
  getViewVisitDate: any;
  todaysDate: any;
  today:any = null;
  visit: any;
  languages:any[] = [];
  selectedLanguage = "English";
  selectedInstructions:any[] = [];
  showLoading = false;
  appointmentData: any;
  general_instruction: string = '';
  covidQues:any = '';
  suggested_investigation: string = '';
  suggested_investigationOri: any = [];
  complaint_diagnosis: string = '';
  complaint_diagnosisOri: any = [];
  chief_complaints: string = '';
  chief_complaintsOri: any = [];
  next_vaccination: string = '';
  complaintsArry: any = [];
  complaintsOriArry: any = [];
  investigationArry: any = [];
  investigationOriArry: any = [];
  diagosisArry: any = [];
  diagosisOriArry: any = [];
  examinationsArry: any = [];
  examinationsOriArry: any = [];
  newComplaint: string = '';
  newDiagnosis: string = '';
  newInvestigation: string = '';
  newExamination: string = '';
  searchComplaint: string = '';
  searchDiagno: string = '';
  searchInvestigation: string = '';
  searchExamination: string = '';
  dateChosen: any = "";
  expirationDate: any = "";
  expirationDateStr: any = "";
  /*prescriptionLists: any[]  = [
        {PrescDates: "Prescription for 12/02/2019" },
        {PrescDates: "Prescription for 22/02/2019",isActive: "true" },
        {PrescDates: "Prescription for 01/03/2019" },
        {PrescDates: "Prescription for 05/03/2019" }
      ];
    prescriptionsListArray: any[] = [
      {drugName: "SOLVIN COLS", genericName: "LS EXP (AMBROXOL)", dosage: "5", unit: "ML", duration: "5 days", totalQty: "75 ML"},
      {drugName: "A-Plus G", genericName: "Domagk Smith (Mecobalamin)", dosage: "1", unit: "ML", duration: "15 days", totalQty: "15 ML"},
      {drugName: "Zerrtio Forte", genericName: "Sanify (Syntonic) (Diclofenac + Paracetamol)",  dosage: "10", unit: "ML", duration: "15 Days", totalQty: "150 ML"},
      {drugName: "Systal [New]", genericName: "Commonwealth (Disodium Hydrogen Citrate)", dosage: "5", unit: "ML", duration: "10 days", totalQty: "100 ML"},
      {drugName: "Rodeo-D [New] ", genericName: " Gokul(Jantec) (Rabeprazole)", dosage: "2", unit: "ML", duration: "12 days", totalQty: "15 ML"},
      {drugName: "Powergest [New]", genericName: " Astraea [Progesterone]", dosage: "5", unit: "ML", duration: "15 days", totalQty: "15 ML"}
    ]
    prescriptionsArray: any[] = [
      {drugName: "SOLVIN COLS",drugType:"LS EXP", genericName: "AMBROXOL", dosage: "5", unit: "ML", duration: "5 days", totalQty: "75 ML"},
      {drugName: "SOLVIN COLS",drugType:"LS EXP", genericName: "AMBROXOL", dosage: "5", unit: "ML", duration: "5 days", totalQty: "75 ML"},
      {drugName: "SOLVIN COLS",drugType:"LS EXP", genericName: "AMBROXOL", dosage: "5", unit: "ML", duration: "5 days", totalQty: "75 ML"}
    ]*/

  constructor(
    private modalService: NgbModal,
    private util: UtilService,
    private authService: AuthService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private patientService: PatientService,
    private toastr: ToastrService,
    private globalService: GlobalService,
    public datepipe: DatePipe,
    private doctorService: DoctorService,

  ) {
    this.userId = this.authService.getUser();
    // this.caseId = localStorage.getItem("viewCaseId")
    //   ? localStorage.getItem("viewCaseId")
    //   : localStorage.getItem("newCaseId");
    // this.visitId = localStorage.getItem("viewVisitId")
    //   ? localStorage.getItem("viewVisitId")
    //   : localStorage.getItem("newVisitId");
    // this.getViewVisitDate = localStorage.getItem("viewCaseVisitDate");
    this.todaysDate = this.datepipe.transform(new Date(), "dd/MM/yyyy");

    var retrievedAppointmentObject:any = localStorage.getItem('appointmentData');
    this.appointmentData = JSON.parse(retrievedAppointmentObject);
    this.covidQues = localStorage.getItem("covidques");
    localStorage.removeItem("covidques");
    this.getConstants();
    this.getPrescriptions(this.appointmentData);
    this.getAge()
    this.medicine.dosage = 'Tablet';
    this.complaintsOriArry = complaints;
    this.complaintsArry = this.complaintsOriArry.sort((a:any, b:any) => a.localeCompare(b));
    this.diagosisOriArry = diagnosis;
    this.diagosisArry = this.diagosisOriArry.sort((a:any, b:any) => a.localeCompare(b));
    this.investigationOriArry = investigations;
    this.investigationArry = this.investigationOriArry.sort((a:any, b:any) => a.localeCompare(b));
    this.examinationsOriArry = on_exam;
    this.examinationsArry = this.examinationsOriArry.sort((a:any, b:any) => a.localeCompare(b));

    //this.route.params.subscribe((params:any) => {
    // if (localStorage.getItem("patientId") && this.visitId) {
    //   this.patientId = localStorage.getItem("patientId");

    //   // this.getVitalsDetails()
    //   this.getConstants();

    //   this.checkIfEditable(this.caseId, this.visitId);
    //   //this.getComplaintDetails()

    //   if (this.caseId && this.visitId) {
    //     this.getVisitDetails(this.caseId, this.visitId);
    //   }
    // } else {
    //   this.router.navigate(["/doctor/patients"]);
    // }
    this.getDoctorCustomPrescriptionItems();
  }

  ngOnInit() {
    this.getVersion();
    this.today = this.util.reverseDate(new Date())

    $("textarea").keyup(function (event:any) {
      let re = /(^|[.!?]\s+)([a-z])/g;
      var textBox: HTMLInputElement = <HTMLInputElement>event.target;
      //textBox.value = textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1).toLowerCase();
      textBox.value = textBox.value.replace(
        re,
        (m, $1, $2) => $1 + $2.toUpperCase()
      );
    });
  }

  // canDeactivate(): any {
  //   return !this.modified;
  // }

  validateNumber(e:any) {
    return (
      (e.charCode > 47 && e.charCode < 58) ||
      e.charCode == 46 ||
      e.which == 8 ||
      e.keyCode == 9
    );
  }

  saveSpecialInstructions() {
    this.medicine.instructions = this.selectedInstructions.join(", ");
  }

  cancel() {
    this.clearSelectedInstructions();
  }

  clearSelectedInstructions() {
    this.selectedInstructions = [];
  }

  selectAllLanguages(e:any) {
    if (e.target.checked) {
      this.selectedInstructions = JSON.parse(
        JSON.stringify(this.specialInstructions[0][this.selectedLanguage])
      );
    } else {
      this.selectedInstructions = [];
    }
  }

  getVersion() {
    this.authService.getVersion().subscribe((response:any) => {
      console.log(response, localStorage.getItem("version"));
      let currentwebapp:any = "";
      if (localStorage.getItem("version")) {
        currentwebapp = localStorage.getItem("version");
      }
      if (response.webapp != currentwebapp) {
        console.log("Need to be refreshed");
        localStorage.setItem("version", response.webapp);
        window.location.reload();
      }
    });
  }
  searchComplaints() {
    if (this.searchComplaint.length < 1) {
      this.complaintsArry = this.complaintsOriArry;
    } else {
      this.complaintsArry = this.complaintsOriArry.filter((complaint:any) => {
        const term = this.searchComplaint.toLowerCase();
        return complaint.toLowerCase().includes(term)
      });
    }
  }

  searchDiagnosis() {
    if (this.searchDiagno.length < 1) {
      this.diagosisArry = this.diagosisOriArry;
    } else {
      this.diagosisArry = this.diagosisOriArry.filter((diagnosis:any) => {
        const term = this.searchDiagno.toLowerCase();
        return diagnosis.toLowerCase().includes(term)
      });
    }
  }
  searchExaminations() {
    if (this.searchExamination.length < 1) {
      this.examinationsArry = this.examinationsOriArry;
    } else {
      this.examinationsArry = this.examinationsOriArry.filter((exam:any) => {
        const term = this.searchExamination.toLowerCase();
        return exam.toLowerCase().includes(term)
      });
    }
  }

  searchInvestigations() {
    if (this.searchInvestigation.length < 1) {
      this.investigationArry = this.investigationOriArry;
    } else {
      this.investigationArry = this.investigationOriArry.filter((investigation:any) => {
        const term = this.searchInvestigation.toLowerCase();
        return investigation.toLowerCase().includes(term)
      });
    }
  }

  addComplaints(complaint:any, isChecked:any, index:any) {
    if (isChecked) {
      this.chief_complaintsOri.push(complaint);
    } else {
      this.chief_complaintsOri = this.chief_complaintsOri.filter((item:any) => item !== complaint);
      var comIndex = this.complaintsArry.indexOf(complaint);

      (<HTMLInputElement>document.getElementById("com" + comIndex)).checked = false;
    }
  }
  closeComplaints(c:any) {
    this.searchComplaint = '';
    this.chief_complaintsOri = [];
    c('close modal');
  }

  closeDiagnosis(c:any) {
    this.searchDiagno = '';
    this.complaint_diagnosisOri = [];
    c('close modal');
  }
  closeInvestigations(c:any) {
    this.searchInvestigation = '';
    this.suggested_investigationOri = [];
    c('close modal');
  }
  SaveComplaints(c:any) {
    if (this.chief_complaintsOri.length < 1) {
      this.toastr.error("Please add some complaints")
    } else {
      this.chief_complaints = this.chief_complaints + this.chief_complaintsOri.join(', ');
      this.chief_complaintsOri = [];
      c('close modal');
    }
  }
  addDiagnosis(diagnosis:any, isChecked:any, index:any) {
    if (isChecked) {
      this.complaint_diagnosisOri.push(diagnosis);
    } else {
      this.complaint_diagnosisOri = this.complaint_diagnosisOri.filter((item:any) => item !== diagnosis);
      var diaIndex = this.diagosisArry.indexOf(diagnosis);

      (<HTMLInputElement>document.getElementById("dia" + diaIndex)).checked = false;
    }
  }

  SaveDiagnosis(c:any) {
    if (this.complaint_diagnosisOri.length < 1) {
      this.toastr.error("Please add some diagnosis")
    } else {
      this.complaint_diagnosis = this.complaint_diagnosis + this.complaint_diagnosisOri.join(', ');
      this.complaint_diagnosisOri = [];
      c('close modal');
    }
  }

  addInvestigations(investigation:any, isChecked:any, index:any) {
    if (isChecked) {
      this.suggested_investigationOri.push(investigation);
    } else {
      this.suggested_investigationOri = this.suggested_investigationOri.filter((item:any) => item !== investigation);
      var invIndex = this.investigationArry.indexOf(investigation);

      (<HTMLInputElement>document.getElementById("inv" + invIndex)).checked = false;
    }

  }
  SaveInvestigation(c:any) {
    if (this.suggested_investigationOri.length < 1) {
      this.toastr.error("Please add some investigations")
    } else {
      this.suggested_investigation = this.suggested_investigation + this.suggested_investigationOri.join(', ');
      this.suggested_investigationOri = [];
      c('close modal');
    }
  }

  addSpecialInstruction(e:any, obj:any) {
    if (e.target.checked) {
      if (this.selectedInstructions) {
        this.selectedInstructions.push(obj);
      } else {
        this.selectedInstructions = [];
        this.selectedInstructions.push(obj);
      }
    } else {
      let index = this.selectedInstructions.indexOf(obj);
      if (index != null) {
        this.selectedInstructions.splice(index, 1);
      }
    }
  }

  checkIfEditable(caseId:any, visitId:any) {
    let params = {
      case_id: caseId,
      visit_id: visitId,
      user_id: this.userId
    };
    this.patientService.checkIfEditable(params).subscribe((response:any) => {
      if (response.success) {
        this.readOnly = response.readOnly;
      }
    });
  }

  calculateQantity() {
    let days = 0;
    if (this.medicine.duration_unit == "months") {
      days = this.medicine.duration * 30;
    } else if (this.medicine.duration_unit == "weeks") {
      days = this.medicine.duration * 7;
    } else {
      days = this.medicine.duration;
    }
    let quantity = this.medicine.dosage * this.medicine.frequency * days;
    this.totalQty = quantity ? quantity : 0;
    this.medicine.quantity = this.totalQty;
  }

  setMedicine(drug:any) {
    this.medicine.Drug = drug;
  }
  AddMore(string:any, w:any) {
    var req_params: any = {};
    if (string === 'com') {
      if (this.newComplaint == "") {
        this.toastr.error("Please add some text");
        return;
      }
      req_params.type = string;
      req_params.text = this.newComplaint;
    } else if (string === 'dia') {
      if (this.newDiagnosis == "") {
        this.toastr.error("Please add some text");
        return;
      }
      req_params.type = string;
      req_params.text = this.newDiagnosis;
    } else if (string === 'inve') {
      if (this.newInvestigation == "") {
        this.toastr.error("Please add some text");
        return;
      }
      req_params.type = string;
      req_params.text = this.newInvestigation;
    }
    else {
      if (this.newExamination == "") {
        this.toastr.error("Please add some text");
        return;
      }
      req_params.type = string;
      req_params.text = this.newExamination;
    }
    this.showLoading = true;
    this.doctorService.addDoctorCustomPrescriptionItem(req_params).subscribe((response:any) => {
      this.showLoading = false;
      if (string === 'com') {
        this.complaintsOriArry.push(this.newComplaint);
        this.complaintsArry = this.complaintsOriArry.sort((a:any, b:any) => a.localeCompare(b));
        this.newComplaint = '';
        this.searchComplaint = '';
        w('close modal');
        this.toastr.success("New complaint added in database successfully");
      } else if (string === 'dia') {
        this.diagosisOriArry.push(this.newDiagnosis);
        this.diagosisArry = this.diagosisOriArry.sort((a:any, b:any) => a.localeCompare(b));
        this.newDiagnosis = '';
        this.searchDiagno = '';
        w('close modal');
        this.toastr.success("New diagnosis added in database successfully");
      } else if (string === 'inve') {
        this.investigationOriArry.push(this.newInvestigation);
        this.investigationArry = this.investigationOriArry.sort((a:any, b:any) => a.localeCompare(b));
        this.newInvestigation = '';
        this.searchInvestigation = '';
        w('close modal');
        this.toastr.success("New investigation added in database successfully");
      }
      else {
        this.examinationsOriArry.push(this.newExamination);
        this.examinationsArry = this.examinationsOriArry.sort((a:any, b:any) => a.localeCompare(b));
        this.newExamination = '';
        this.newInvestigation = '';
        w('close modal');

      }
    });
  }
  searchMedicines(e:any) {
    if (e.query.length > 2 && e.originalEvent.inputType == "insertText") {
      this.getDrugs(e.query);
    }
  }

  filterMedicines(query:any, list:any) {
    let filtered: any[] = [];
    for (let i = 0; i < list.length; i++) {
      let drug = list[i];
      if (drug.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(drug);
      }
    }
    return filtered;
  }

  addMedicine() {
    // if(this.validateMedicine()){
    this.medicineList.push(this.medicine);
    this.drug = null;
    this.medicine = { Drug: {}, duration_unit: "days", frequency: 1 };
    this.totalQty = 0;
    //}
  }

  checkIfMedicineExists() { }

  validateMedicine() {
    this.medicineError = null;
    let quantity =
      Number(this.medicine.morning ? this.medicine.morning : 0) +
      Number(this.medicine.noon ? this.medicine.noon : 0) +
      Number(this.medicine.afternoon ? this.medicine.afternoon : 0) +
      Number(this.medicine.evening ? this.medicine.evening : 0) +
      Number(this.medicine.night ? this.medicine.night : 0) +
      Number(this.medicine.midnight ? this.medicine.midnight : 0);

    let duration =
      Number(this.medicine.days ? this.medicine.days : 0) +
      Number(this.medicine.months ? this.medicine.months : 0) +
      Number(this.medicine.weeks ? this.medicine.weeks : 0);

    if (!this.medicine.Drug.product_name) {
      this.medicineError = "Please select Drug";
    } else if (!this.medicine.dosage) {
      this.medicineError = "Please select dosage";
    } else if (!Number(quantity)) {
      this.medicineError = "Please select time of the day";
    } else if (!this.medicine.medicine_guide) {
      /*if(!Number(this.medicine.frequency)){
      this.medicineError = "Please enter all the required fields"
    }*/
      this.medicineError =
        "Please select specific instruction when to take medicine";
    } else if (!Number(duration)) {
      this.medicineError = "Please enter duration";
    }
    this.medicineList.forEach((med: any, index: any) => {
      if (
        med.Drug.product_id == this.medicine.Drug.product_id &&
        this.editIndex != index
      )
        this.medicineError = "Medicine has been added already";
    });
    if (!this.medicineError) return true;
    else return false;
  }

  saveMedicine() {
    let frequency = 0;
    if (this.medicine.morning) {
      frequency = frequency + 1;
    }
    if (this.medicine.noon) {
      frequency = frequency + 1;
    }
    if (this.medicine.afternoon) {
      frequency = frequency + 1;
    }
    if (this.medicine.evening) {
      frequency = frequency + 1;
    }
    if (this.medicine.night) {
      frequency = frequency + 1;
    }
    if (this.medicine.midnight) {
      frequency = frequency + 1;
    }
    this.medicine.frequency = frequency;
    let valid = this.validateMedicine();
    if (valid) {
      this.medicineList.push(this.medicine);
      this.addNewMedicine();
    }
  }

  ngOnDestroy() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  deleteMedicine(index:any, d:any) {
    this.confirmationService.confirm({
      message: "Are you sure you want to remove this medicine?",
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        if (this.medicineList[index].id) {
          this.deletedMedicines.push(this.medicineList[index].id);
        }
        this.medicineList.splice(index, 1);
        this.addNewMedicine();
      },
      reject: () => { }
    });
  }

  editMedicine(medicine:any, i:any) {
    this.drug = medicine.Drug;
    this.editIndex = i;
    this.medicine = JSON.parse(JSON.stringify(medicine));
    this.addMedicineSection = true;
    //this.calculateQantity()
  }

  updateMedicine() {
    let frequency = 0;
    if (this.medicine.morning) {
      frequency = frequency + 1;
    }
    if (this.medicine.noon) {
      frequency = frequency + 1;
    }
    if (this.medicine.afternoon) {
      frequency = frequency + 1;
    }
    if (this.medicine.evening) {
      frequency = frequency + 1;
    }
    if (this.medicine.night) {
      frequency = frequency + 1;
    }
    if (this.medicine.midnight) {
      frequency = frequency + 1;
    }
    this.medicine.frequency = frequency;
    if (this.validateMedicine()) {
      this.medicineList[this.editIndex] = this.medicine;
      this.drug = null;
      this.editIndex = null;
      this.addNewMedicine();
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  addLabelAutoComplete(e:any) {
    $(e.target.parentElement.parentElement.parentElement.children[1]).addClass(
      "animatedLabel"
    );
  }

  removeLabelAutoComplete(e:any) {
    if (e.target.value == "") {
      $(
        e.target.parentElement.parentElement.parentElement.children[1]
      ).removeClass("animatedLabel");
    } else {
      $(
        e.target.parentElement.parentElement.parentElement.children[1]
      ).addClass("animatedLabel");
    }
  }

  getPatientDeatils() {
    let params = {
      user_id: this.userId,
      patient_id: this.patientId,
      include_siblings: false
    };
    this.patientService.getBasicInfo(params).subscribe((respose:any) => {
      if (respose.success) {
        this.patient = respose.patient;
        this.age = this.util.calculateAge(this.patient.User.dob);
        this.selectedLanguage = this.patient.language
          ? this.languages[this.patient.language]
          : "English";
        //this.profileImage = respose.patient.User.profile_photo ? 'https://s3.ap-south-1.amazonaws.com/copd-dev/copd-dev/images/profile_images/Patient/' + respose.patient.User.profile_photo : "assets/images/user_default.png"
      }
    });
  }

  getVisitDetails(caseID:any, visitID:any) {
    var req_params = { case_id: caseID, visit_id: visitID };
    this.patientService.getVisitDetails(req_params).subscribe((response:any) => {
      if (response.success == true) {
        this.visit = response.visit ? response.visit : {};
        //this.getPrescriptions();
      }
    });
  }

  getPrescriptions(appointmentData:any) {
    this.showLoading = true;
    // let params = {
    //   user_id: this.visit.DoctorId,
    //   patient_id: this.patientId,
    //   visit_id: this.visitId,
    //   case_id: this.caseId
    // };
    this.patientService.getPrescriptions(appointmentData).subscribe((respose:any) => {
      this.showLoading = false;
      if (respose.success) {
        /*if(respose.current_prescription.length > 0){
          let today = new Date()
          let visitDate = new Date(respose.current_prescription[0].createdAt)
          var diff = Math.abs(today.getTime() - visitDate.getTime()) / 3600000;
          if(respose.current_prescription[0].Doctor.User.id != this.userId || diff > 24){
            this.readOnly = true
          }
        }*/

        this.ownPrescriptions =
          respose.own_prescriptions.length > 0 ? respose.own_prescriptions : [];
        this.otherPrescriptions = respose.other_prescriptions;
        this.medicineList =
          respose.current_prescription.length > 0
            ? respose.current_prescription[0].Medicines
            : [];
        this.visit = respose.visit.length ? respose.visit[0] : [];
        this.appointmentData = respose.appointment
        if (this.medicineList.length > 0) {
          this.readOnly = true;
        }

        this.general_instruction = respose.visit.length && respose.visit[0].general_instruction && this.general_instruction == "" ? respose.visit[0].general_instruction : this.general_instruction;
        if (this.covidQues == '' || this.covidQues == null) {
          this.covidQues = respose.visit.length && respose.visit[0].covidQues ? respose.visit[0].covidQues : '';
        }
        this.complaint_diagnosis = respose.visit.length && respose.visit[0].complaint_diagnosis ? respose.visit[0].complaint_diagnosis : '';
        this.chief_complaints = respose.visit.length && respose.visit[0].chief_complaints ? respose.visit[0].chief_complaints : '';
        this.next_vaccination = respose.visit.length && respose.visit[0].next_vaccination ? respose.visit[0].next_vaccination : '';
        this.suggested_investigation = respose.visit.length && respose.visit[0].suggested_investigation ? respose.visit[0].suggested_investigation : '';
        this.expirationDateStr = respose.visit.length && respose.visit[0].expirationDate ? respose.visit[0].expirationDate : '';


      } else {
      }
    });
  }

  getDoctorCustomPrescriptionItems() {
    this.doctorService.getDoctorCustomPrescriptionItems().subscribe((response:any) => {
      if (response.success) {
        if (response.doctorCustomPrescriptionItems && response.doctorCustomPrescriptionItems.length > 0) {
          for (let index = 0; index < response.doctorCustomPrescriptionItems.length; index++) {
            const element = response.doctorCustomPrescriptionItems[index];
            if (element.type === 'com') {
              this.complaintsOriArry.push(element.text);
              this.complaintsArry = this.complaintsOriArry.sort((a:any, b:any) => a.localeCompare(b));
            } else if (element.type === 'dia') {
              this.diagosisOriArry.push(element.text);
              this.diagosisArry = this.diagosisOriArry.sort((a:any, b:any) => a.localeCompare(b));
            }
            else if (element.type === 'inve') {
              this.investigationOriArry.push(element.text);
              this.investigationArry = this.investigationOriArry.sort((a:any, b:any) => a.localeCompare(b));
            }
            else {
              this.examinationsOriArry.push(element.text);
              this.examinationsArry = this.examinationsOriArry.sort((a:any, b:any) => a.localeCompare(b));
            }


          }
        }
      } else {
      }
    });
  }

  getVitalsDetails() {
    var req_params = { caseId: this.caseId, visitId: this.visitId };
    /*this.patientService.getVitalDetails(req_params).subscribe((response) =>{
      if(response.success == true){
        this.vitals = response.visit.Vital

      }
    })*/
  }

  addNewMedicine() {
    this.medicineError = null;
    this.editIndex = null;
    this.drug = null;
    this.medicine = {
      Drug: {},
      morning: 0,
      noon: 0,
      afternoon: 0,
      evening: 0,
      night: 0,
      midnight: 0,
      medicine_guide: null,
      instructions: null,
      days: null,
      weeks: null,
      months: null,
      dosage: "Tablet"
    };

    //this.medicineList = this.newPrescription.Medicines.length == 0 ? [] : JSON.parse(JSON.stringify(this.newPrescription.Medicines))
  }

  copyPrescription(prescription:any) {
    this.medicineError = null;
    this.editIndex = null;
    this.drug = null;
    if (this.medicineList.length > 0) {
      this.confirmationService.confirm({
        message: "Are you sure you want to remove the added medicine list?",
        header: "Confirmation",
        icon: "fa fa-question-circle",
        accept: () => {
          this.medicine = { Drug: {}, duration_unit: "days", frequency: 1 };
          this.medicineList = JSON.parse(
            JSON.stringify(prescription.Medicines)
          );
          this.medicineList.map(med => {
            delete med["id"];
          });
        },
        reject: () => { }
      });
    } else {
      this.medicine = { Drug: {}, duration_unit: "days", frequency: 1 };
      this.medicineList = JSON.parse(JSON.stringify(prescription.Medicines));
      this.medicineList.map(med => {
        delete med["id"];
      });
    }
  }

  exitVisit() {
    localStorage.removeItem("viewCaseId");
    localStorage.removeItem("newCaseId");
    localStorage.removeItem("viewVisitId");
    localStorage.removeItem("newVisitId");
    this.toastr.success("Patient record updated");
    this.router.navigate([`/doctor/patients`]);
  }

  viewPrescription(type:any) {
    if (type == "other") {
      this.viewPrescriptionList = this.otherPrescriptions;
      this.selectedPrescription = this.otherPrescriptions[0];
    } else {
      this.viewPrescriptionList = this.ownPrescriptions;
      this.selectedPrescription = this.ownPrescriptions[0];
    }
  }

  getSortedMedicines(medicines:any, sort:any) {
    return orderBy(medicines, sort, "desc");
  }

  getConstants() {
    this.globalService.getConstants().subscribe((response:any) => {
      this.medicineInstructions = response.medicine_instructions;
      this.specialInstructions = response.special_instructions;
      this.languages = response.languages;
      //this.getPatientDeatils();
    });
  }

  closeCalender(e:any, d:any) {
    if (this.dateChosen != '') {

      var date = new Date(this.util.parseDate(this.dateChosen));
      let month = null;
      month = date.getMonth() + 1;
      if (month < 10) {
        {
          month = '0' + month;
        }
      }
      let day = null;
      day = date.getDate();
      if (day < 10) {
        {
          day = '0' + day;
        }
      }
      let dateStr = `${day}/${month}/${date.getFullYear()}`
      this.next_vaccination = dateStr + ": " + this.next_vaccination;
      if ((this.next_vaccination.split(":").length - 1) > 1) {
        var arr = this.next_vaccination.split(":");
        this.next_vaccination = arr[0] + ": " + arr[arr.length - 1].trim();
      }
      this.dateChosen = "";
    }
    if (d._elRef.nativeElement.parentElement.contains(e.target)) {

    } else {
      d.close()
    }
    if (e.target.offsetParent == null)
      d.close()
    // else if (e.target.offsetParent && e.target.offsetParent.nodeName != "NGB-DATEPICKER" && (e.target.offsetParent.className.indexOf('calender') == -1 && e.target.offsetParent.className.indexOf('custom-select') == -1))
    //   d.close()
  }

  closeCalenderForExp(e:any, d:any) {
    if (this.expirationDate != '') {

      var date = new Date(this.util.parseDate(this.expirationDate));
      let month = null;
      month = date.getMonth() + 1;
      if (month < 10) {
        {
          month = '0' + month;
        }
      }
      let day = null;
      day = date.getDate();
      if (day < 10) {
        {
          day = '0' + day;
        }
      }
      this.expirationDateStr = `This prescription is valid up to - ${day}/${month}/${date.getFullYear()}`
      if ((this.expirationDateStr.split("-").length - 1) > 1) {
        var arr = this.expirationDateStr.split("-");
        this.expirationDateStr = arr[0] + "- " + arr[arr.length - 1].trim();
      }
      // this.expirationDate = "";
    }
    if (d._elRef.nativeElement.parentElement.contains(e.target)) {

    } else {
      d.close()
    }
    if (e.target.offsetParent == null)
      d.close()
    // else if (e.target.offsetParent && e.target.offsetParent.nodeName != "NGB-DATEPICKER" && (e.target.offsetParent.className.indexOf('calender') == -1 && e.target.offsetParent.className.indexOf('custom-select') == -1))
    //   d.close()
  }

  getAge() {
    this.age = {};
    let age = this.calculateAge(new Date(), new Date(this.appointmentData.Patient.User["dob"]));
    this.age["years"] = age[0];
    this.age["months"] = age[1];
  }

  calculateAge(today:any, birthDate:any) {
    let differenceInMilisecond = today.valueOf() - birthDate.valueOf();
    let year = Math.floor(differenceInMilisecond / 31536000000);
    let day = Math.floor((differenceInMilisecond % 31536000000) / 86400000);
    let months = Math.floor(day / 30);
    return [year, months];
  }

  addLabelClass(e:any) {
    $(e.target.parentElement.children[1]).addClass("animatedLabel");
  }
  removeLabelClass(e:any) {
    if (e.target.value == "") {
      $(e.target.parentElement.children[1]).removeClass("animatedLabel");
    }
  }
  closePrescription() {
    this.router.navigate(['/doctor/homepage'])
  }
  savePrescription() {
    // if (this.validatePrescription()) {
    this.modified = false;
    let params = {
      user_id: this.userId,
      visit: {
        complaint_diagnosis: this.complaint_diagnosis,
        general_instruction: this.general_instruction,
        chief_complaints: this.chief_complaints,
        next_vaccination: this.next_vaccination,
        suggested_investigation: this.suggested_investigation,
        covidQues: this.covidQues,
        expirationDate: this.expirationDateStr
      },
      patient_id: this.appointmentData.PatientId,
      visit_id: this.appointmentData.VisitId,
      medicine_list: this.medicineList,
      deleted_medicines: this.deletedMedicines,
    };

    this.patientService.createPrescription(params).subscribe((respose:any) => {
      if (respose.success) {
        this.getPrescriptions(this.appointmentData);
        this.toastr.success("Prescription has been created successfully");
        /*this.router.navigate(["/doctor/patients"])
        localStorage.removeItem('viewCaseId')
        localStorage.removeItem('viewVisitId')
        localStorage.removeItem('newCaseId')
        localStorage.removeItem('newVisitId')*/
        //this.patient = respose.patient
        //this.getAge()
        //this.profileImage = respose.patient.User.profile_photo ? 'https://s3.ap-south-1.amazonaws.com/copd-dev/copd-dev/images/profile_images/Patient/' + respose.patient.User.profile_photo : "assets/images/user_default.png"
      } else {
        this.toastr.error(respose.error);
        //this.router.navigate(["/doctor/patients"])
      }
    });
    // }
  }

  capitalize(e:any) {
    let re = /(^|[.!?]\s+)([a-z])/g;
    var textBox: HTMLInputElement = <HTMLInputElement>e.target;
    //textBox.value = textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1).toLowerCase();
    textBox.value = textBox.value.replace(
      re,
      (m, $1, $2) => $1 + $2.toUpperCase()
    );
  }

  validatePrescription() {
    this.prescriptionErrors = {};
    if (this.medicineList.length == 0) {
      this.prescriptionErrors["medicines"] =
        "Please add medicines before saving.";
    }
    if (Object.keys(this.prescriptionErrors).length == 0) return true;
    else return false;
  }

  getDrugs(query:any) {
    var queryString: any = { query: query };
    this.globalService.getDrugs(queryString).subscribe((response:any) => {
      this.drugs = response.drugs;
      this.originalDrugs = response.drugs;
    });
  }

  getComplaintDetails() {
    let params = {
      visit_id: this.visitId
    };
    this.patientService.getComplaint(params).subscribe((response:any) => {
      if (response.success) {
        this.complaint = response.visit.Complaint;
      }
    });
  }

  //function to open modal box
  open(content:any, customClass: any = '') {
    this.modalRef = this.modalService.open(content, { size: customClass })
    this.modalRef.result.then((result:any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason:any) => {
      this.closeResult = `Dismissed ${reason}`;
    });

  }

  // getInstructions(text) {
  //   if (text == null || text == '') {
  //     return ''
  //   }
  //   else {
  //     var arr = text.split('[COVID]');
  //     var str = arr.join('');
  //     var arr1 = str.split('||');
  //     var str1 = arr1.join('');
  //     var arr2 = str1.split('(');
  //     var str2 = arr2.join('');
  //     var arr3 = str2.split(')');
  //     var str3 = arr3.join('');
  //     return str3;
  //   }
  // }


  print(action:any) {
    // if (this.medicineList.length < 1) {
    //   this.toastr.error("Please add atleast one medicine");
    // }
    // else {
    let params: any;
    params = {
      user_id: this.appointmentData.DoctorId,
      visit_id: this.appointmentData.VisitId,
      clinic_id: this.appointmentData.ClinicId,
      read_only: false,
      date: this.appointmentData.visit_date,
      //read_only: true,
      appointmentId: this.appointmentData.id,
      action: action,
      patient: {
        id: this.appointmentData.PatientId,
        first_name: this.appointmentData.Patient.User.first_name,
        last_name: this.appointmentData.Patient.User.last_name,
        age: this.age,
        gender: this.appointmentData.Patient.User.gender,
        weight: "N/A",
        height: "N/A",
        phone_number: this.appointmentData.Patient.User.phone_number,
        CustomerId: this.appointmentData.Patient.User.CustomerId,
      },
      medicines: this.medicineList,
    };
    params.general_instruction = this.general_instruction;
    params.covidQues = this.covidQues,
      params.suggested_investigation = this.suggested_investigation;
    params.chief_complaints = this.chief_complaints;
    params.next_vaccination = this.next_vaccination;
    params.expirationDate = this.expirationDateStr;
    /*if(this.complaint){
      params['chief_complaint'] = this.complaint.chief_complaints ? this.complaint.chief_complaints : 'N/A',
        params['on_examination'] = this.complaint.complaint_examination ? this.complaint.complaint_examination : 'N/A',
        params['diagnosis'] = this.complaint.complaint_diagnosis ? this.complaint.complaint_diagnosis : 'N/A'
    } else {
      params['chief_complaint'] = 'N/A'
      params['on_examination'] = 'N/A'
      params['diagnosis'] = 'N/A'
    }*/
    (params["chief_complaint"] = this.visit.chief_complaints
      ? this.visit.chief_complaints
      : "N/A"),
      (params["on_examination"] = this.visit.complaint_examination
        ? this.visit.complaint_examination
        : "N/A"),
      params.complaint_diagnosis = this.complaint_diagnosis
    this.showLoading = true;


    let savePrescriptionParams = {
      user_id: this.userId,
      visit: {
        complaint_diagnosis: this.complaint_diagnosis,
        general_instruction: this.general_instruction,
        chief_complaints: this.chief_complaints,
        next_vaccination: this.next_vaccination,
        suggested_investigation: this.suggested_investigation,
        covidQues: this.covidQues,
        expirationDate: this.expirationDateStr
      },
      patient_id: this.appointmentData.PatientId,
      visit_id: this.appointmentData.VisitId,
      medicine_list: this.medicineList,
      deleted_medicines: this.deletedMedicines,
    };
    params.savePrescriptionParams = savePrescriptionParams;
    this.patientService.printPrescription(params).subscribe(
      data => {
        this.showLoading = false;
        this.getPrescriptions(this.appointmentData);
        if (action == 'preview') {
          this.downloadUrl(data.url, `Report.pdf`);
        }
        else {
          this.toastr.success("Link sent to patient successfully")
        }
        //saveAs(data, 'test.pdf');
      },
      err => {
        this.showLoading = false;
        alert("Problem while downloading the file.");
        console.error(err);
      }
    );
    // }
  }

  downloadUrl(url: string, fileName: string) {
    /*let a: any = document.createElement('a');
    a.href = url;
    a.target = '_blank'
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();*/
    window.open(url, "_blank");
  }

  // goToPrevTab() {
  //   this.router.navigate([`/doctor/patients/investigations/view`]);
  // }

  // goToNextTab() {
  //   this.router.navigate([`/doctor/patients/growthnutrition/view`]);
  // }
}
